var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var LinkWrapper = require('./linkWrapper.jsx')(Link);

var Footer = createReactClass({

  render: function(){
    return (
        <footer id="footer">
            <nav>
                <LinkWrapper to="/app" handler={this.props.clickTracking}>Get the App</LinkWrapper>
                <LinkWrapper to="/blog" handler={this.props.clickTracking}>Blog</LinkWrapper>
				<LinkWrapper to="/about" handler={this.props.clickTracking}>About Us</LinkWrapper>
                <LinkWrapper to="/partners" handler={this.props.clickTracking}>Partners</LinkWrapper>
                <LinkWrapper to="/privacy" handler={this.props.clickTracking}>Privacy</LinkWrapper>
                <LinkWrapper to="/terms" handler={this.props.clickTracking}>Terms &amp; Conditions</LinkWrapper>
                <LinkWrapper to="/help" className="end" handler={this.props.clickTracking}>Help</LinkWrapper>
            </nav>
        </footer>
    )
  }
});

module.exports = Footer;



// WEBPACK FOOTER //
// ./src/common/routes/components/footer.jsx